import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL + "/delivery-configs";

const setTokenAllHeaders = async () => {
    const token = localStorage.getItem("adminToken");
    axios.defaults.headers.common["Authorization"] = token;
};

const getDeliveryOptions = async ({ limit = 10, page = 0, status = null, sortModel = [], filterModel = [], branchId = null, deliTypeId = null }) => {
    try {
        await setTokenAllHeaders();
        let sendStatus = status;
        if (sendStatus === 0) {
            sendStatus = null;
        }
        let search = null;
        if (filterModel['quickFilterValues']) {
            search = filterModel['quickFilterValues'][0] || null;
        }
        const response = await axios.get(`${BASE_URL}`, {
            params: {
                limit,
                page,
                status: sendStatus,
                search,
                sort: sortModel,
                branchId,
                deliveryTypeId: deliTypeId
            },
        });
        return response.data;
    }
    catch (error) {
        console.error('Error fetching delivery options:', error);
        throw error;
    }
}

const addDeliveryOption = async (deliveryOption) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}`, deliveryOption);
        return response.data;
    } catch (error) {
        console.error("Error adding delivery option", error);
        throw error;
    }
}
const updateDeliveryOption = async (id, deliveryOption) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/${id}`, deliveryOption);
        return response.data;
    } catch (error) {
        console.error("Error adding delivery option", error);
        throw error;
    }
}

const updateDeliveryConfigStatus = async ({ id, status, reason = null }) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/${id}/status`, { status, reason });
        return response.data;
    } catch (error) {
        console.error("Error updating delivery config status", error);
        throw error;
    }
};




const deliveryApi = {
    getDeliveryOptions,
    addDeliveryOption,
    updateDeliveryOption,
    updateDeliveryConfigStatus
};

export default deliveryApi;
